import interceptor from '../common/interceptor';
import { APIPaths } from '../common/constants';
import { ApiResponse, PermissionsApiResponse } from '@/apis/types';
import {
  RoleModel,
  RefreshTokenResponse,
} from '@/pages/Settings/RolesAndPermissions/utils/types';
import { OperationType } from '@/common/enum';

export interface RoleLiteItem {
  id: string;
  name: string;
  [key: string]: unknown;
}

export interface GetRolesLiteResponse {
  data: {
    data: {
      is_success?: boolean;
      data?: RoleLiteItem[];
      page_count?: number;
      total_count?: number;
      message?: string;
    };
  };
}

// Fetch roles lite for dropdowns (with pagination & search support)
export const GetRolesLite = (
  page: number = 1,
  search?: string,
  pageSize: number = 20
): Promise<GetRolesLiteResponse> => {
  return new Promise((resolve, reject) => {
    const params = new URLSearchParams({
      lite: 'true',
      page: String(page),
      ...(search ? { search: search.trim() } : {}),
      page_size: String(pageSize),
    });

    interceptor
      .axiosGet('Get', `${APIPaths.role}?${params.toString()}`, null, null)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.error('Error fetching roles lite:', error?.response);
        reject(error?.response);
      });
  });
};

// get all roles and permission table data
export const GetRoles = (token: string): Promise<ApiResponse<RoleModel[]>> => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosGet('Get', APIPaths.role, token, null)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.log('error?.response?.data?.error', error?.response);
        reject(error?.response);
      });
  });
};

// API call for SAVE NEW ROLE
export const AddNewRole = (token: string, model: unknown): Promise<unknown> => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosPost('Post', APIPaths.add_role, model, token)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.log('Error while adding new role:', error?.response);
        reject(error?.response);
      });
  });
};

export const ChangeRolePermission = (
  token: string,
  model: unknown
): Promise<PermissionsApiResponse> => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosPost('Post', APIPaths.role_permissions, model, token)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.log('Error while adding new role:', error?.response);
        reject(error?.response);
      });
  });
};

export const ClearCache = (): Promise<PermissionsApiResponse> => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosPost('Post', APIPaths.clear_cache, {})
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.log('Error while clearing cache:', error?.response);
        reject(error?.response);
      });
  });
};
export const RefreshToken = (
  token: string,
  model: unknown
): Promise<RefreshTokenResponse> => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosPost(
        'Get',
        APIPaths.refresh_token,
        model,
        token,
        null,
        OperationType.NonBlockedWrite
      )
      .then((res) => {
        resolve(res.data as RefreshTokenResponse);
      })
      .catch((error) => {
        console.error('Error while refreshing token:', error?.response);
        reject(error?.response);
      });
  });
};

export const DeleteRole = (id: string, token: string): Promise<unknown> => {
  const url = `${APIPaths.role}${id}/`;
  return new Promise((resolve, reject) => {
    interceptor
      .axiosDelete('Delete', url, null, token)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.log('error?.response?.data?.error', error?.response);
        reject(error?.response);
      });
  });
};
export const GetPermissionsOptions = (token: string): Promise<ApiResponse> => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosGet('Get', APIPaths.permission_options, token, null)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.log('error?.response?.data?.error', error?.response);
        reject(error?.response);
      });
  });
};

export interface RolePreviewPayload {
  role_id: string;
  team_ids: string[];
}

export interface RolePreviewAssignment {
  team_id: string;
  team_name: string;
  role_id: string;
  role_name: string;
}

export interface RolePreviewResponse {
  data: {
    data?: {
      data?: {
        access?: string;
        refresh?: string;
      };
      message?: string;
      is_success?: boolean;
    };
  };
}

export const RolePermissionPreviewApi = (
  payload: RolePreviewPayload
): Promise<RolePreviewResponse> => {
  return new Promise((resolve, reject) => {
    const token = localStorage.getItem('@token');
    interceptor
      .axiosPost(
        'Post',
        APIPaths.rolesPreview,
        payload,
        token || undefined,
        null,
        OperationType.NonBlockedWrite
      )
      .then((res) => {
        resolve(res as RolePreviewResponse);
      })
      .catch((error) => {
        console.log('error?.response?.data?.error', error?.response);
        reject(error?.response || error);
      });
  });
};
